<template>
  <Layout theme="light">
    <HeaderComponents></HeaderComponents>
    <Content class="content">
      <div class="banner">
        <p>欢迎使用</p>
        <p>艺棒小匠服务平台</p>
        <div class="playOrder" @click="toPublic">立即下单 →</div>
      </div>
      <!----下单模式-->
      <div class="order_mode" id="playOrder">
        <div class="order-mode-title">
          <img width="10" src="../../assets/images/xiexian.png" />
          <span>服务品类齐</span>
          <span class="theme">全，</span>
          <span class="theme">多</span>
          <span>种下单模式</span>
          <img width="10" src="../../assets/images/xiexian.png" />
        </div>
        <div class="mode-list">
          <div v-for="(item,index) in serverList" :key='index'>
            <div class="mode-item" @click="toPage(item)">
              <img :src="item.thumbnail" alt>
              <span>{{item.name}}</span>
            </div>
          </div>
        </div>
      </div>
      <div id="advantage" class="advantage">
        <div class="order-mode-title">
          <img width="10" src="../../assets/images/xiexian.png" />
          <span>我们的优势</span>
          <img width="10" src="../../assets/images/xiexian.png" />
        </div>
        <div class="advantage-list">
          <div class="advantage-item">
            <span>服务一口价</span>
            <img src="../../assets/images/yikoujia.png" />
          </div>
          <div class="advantage-item">
            <span>服务成本低</span>
            <img src="../../assets/images/chengbendi.png" />
          </div>
          <div class="advantage-item">
            <span>服务有保障</span>
            <img src="../../assets/images/baozhang.png" />
          </div>
        </div>
      </div>
      <img width="10" style="width: 100%;margin-bottom: 10px;" src="../../assets/images/2.jpg" />
      <div class="company" id="about">
        <img src="../../assets/images/1.jpg" alt>
        <div class="company-content">
          <div class="title">公司简介</div>
					<div v-html='teacherInfo.pc_index_company_desc'></div>
          <!-- <div class="desc">齐师傅商务信息咨询有限公司，于2000年开始运作，2019年因业务需要再次升级，公司依托于中国生活类大环境，充分利用师傅服务优势，致力于大型生活类服务工作。</div>
          <div class="sub-title">企业愿景</div>
          <div class="sub-content">成为中国一流的家居后市场服务平台</div>
          <div class="sub-title">企业使命</div>
          <div class="sub-content">为客户提供高效率高质量服务，为员工创造更大价值，搭建广阔舞台</div>
          <div class="sub-title remarks">核心价值观</div>
          <div class="sub-content">诚信与责任并存</div>
          <div class="sub-title">企业作风</div>
          <div class="sub-content">勤奋、严谨、求真、务实</div> -->
        </div>
      </div>
      <div class="range" id="ServiceArea">
        <div class="order-mode-title">
          <img width="10" src="../../assets/images/xiexian.png" />
          <span>艺棒小匠客服覆盖范围</span>
          <img width="10" src="../../assets/images/xiexian.png" />
        </div>
        <div class="range-content">
          <div class="range-view">
            <div class="range-item flex align-center justify-center flex-direction">
              <div class="title">线下师傅</div>
              <div class="num">{{teacherInfo.worker_number}}</div>
            </div>
            <div class="range-item flex align-center justify-center flex-direction">
              <div class="title">服务地区</div>
              <div class="num">{{teacherInfo.service_area}}个县市</div>
            </div>
            <div class="range-item flex align-center justify-center flex-direction">
              <div class="title">服务网点</div>
              <div class="num">{{teacherInfo.service_network}}</div>
            </div>
          </div>

        </div>
        <div class="range-desc">
          <div class="title">师傅覆盖全国</div>
          <div class="desc">取现售后无盲区，帮助商家构建全国售后网点，为销售提供强力支撑</div>
        </div>
      </div>
      <div class="service" id="Service">
        <div class="box flex align-center justify-center">
          <div class="tel-view text-white">
            <img src="../../assets/images/call.png" alt>
            <div class="call-view">
              <div class="text">联系我们</div>
              <div class="tel">{{teacherInfo.contact}}</div>
            </div>
          </div>
        </div>
      </div>
     <!-- <div class="order_mode" id="Mode">
        <div class="order-mode-title">
          <img width="10" src="../../assets/images/xiexian.png" />
          <span>新老模式对比</span>
          <img width="10" src="../../assets/images/xiexian.png" />
        </div>
        <div class="mode-view">
          <div class="master-view">
            <div class="title">艺棒小匠</div>
            <div class="sub">
              <div class="title">找师傅方式</div>
              <div class="desc">发布需求就会有报价<br /> 做到等着师傅来服务</div>
            </div>
            <div class="sub">
              <div class="title">师傅质量</div>
              <div class="desc">实名制认证<br /> 经严格培训方可入驻<br />定期接受线上线下专业培训</div>
            </div>
            <div class="sub">
              <div class="title">谈价方式</div>
              <div class="desc">对比报价选择能接受价位<br />或者直接一口价</div>
            </div>
          </div>
          <div class="pk">PK</div>
          <div class="other-view">
            <div class="title">传统模式</div>
            <div class="sub">
              <div class="title">找师傅方式</div>
              <div class="desc">58、QQ群苦苦寻找<br /> 信息杂乱且难辨真假</div>
            </div>
            <div class="sub">
              <div class="title">师傅质量</div>
              <div class="desc">电话是唯一联系<br />很难知道师傅服务水平</div>
            </div>
            <div class="sub">
              <div class="title">谈价方式</div>
              <div class="desc">价格高，让价难中途加价只能自认倒霉</div>
            </div>
          </div>
        </div>
      </div> -->
      <div class="register-view" v-if="userInfo==''">
        <div class="view">
          <div class="remarks">立即注册，即可免费体验艺棒小匠为您服务</div>
          <div class="btn" @click="$router.push({name:'register'})">立即注册</div>
        </div>
      </div>
    </Content>
    <!-- <LevitationButton></LevitationButton> -->
    <FooterComponents></FooterComponents>
  </Layout>
</template>
<script>
  // @ is an alias to /src
  import HeaderComponents from './components/header'
  import FooterComponents from './components/footer'
  // import LevitationButton from './components/levitation'

  export default {
    name: 'home',
    components: {
      HeaderComponents,
      FooterComponents,
      // LevitationButton
    },
    data() {
      return {
        serverList: [], //服务类目
        messageInfo: '', //
				teacherInfo:'',//师傅信息
				kfPhone:'',//客服电话
        userInfo:'',
      }
    },
    created() {

      let vm = this
      this.$request('611b5e915c69e', {}).then(res => {
        vm.serverList = res.data.data.list
      })
			// 师傅信息
			this.$request('635663a939a14', {}).then(res => {
			  vm.teacherInfo = res.data.data
			})
      console.log(global.userInfo,'global.userInfo=====');
      if (global.userInfo) {
        this.userInfo = global.userInfo
        this.$request('62cfd88b56ba2', {}).then(res => {
          vm.messageInfo = res.data.data.least_system
        })
      }
    },
    methods: {
      
      toPage(item) {
        if (!global.userInfo) {
          return this.$router.push({
            name: 'login'
          })
        }
        this.$router.push({
          name: 'place',
          params: {
            id: item.id
          }
        })
      },
      toPublic() {
        if (!global.userInfo) {
          return this.$router.push({
            name: 'login'
          })
        }
        this.$router.push({
          name: 'place',

        })
      },
    },
  }
</script>

<style scoped lang="less">
  .content {
    margin-top: 64px;

    .bg-message {
      line-height: 60px;
      background-color: rgb(254, 241, 236);
    }

    .banner {
      width: 100%;
      height: 500px;
      background-image: url("../../assets/images/banner2.jpg");
      background-repeat: no-repeat;
      background-size: contain;
      background-position: center;
      padding: 0 100px;
      display: flex;
      flex-direction: column;
      justify-content: center;

      p {
        font-style: normal;
        font-weight: 600;
        font-size: 40px;
        line-height: 62px;
        color: #FC8B03;
      }

      .playOrder {
        width: 125px;
        height: 40px;
        background: #FC8B03;
        border-radius: 41px;
        margin-top: 20px;
        line-height: 40px;
        text-align: center;
        color: #FFFFFF;
        font-weight: 600;
        cursor: pointer;
      }
    }

    .order_mode,
    .advantage,
    .range {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background-color: #FFFFFF;

      .order-mode-title {
        display: flex;
        height: 130px;
        align-items: center;
        font-weight: 600;

        img {
          margin: 0 10px;
        }

        .theme {
          color: #FB9E2F;
        }
      }

      .mode-list {
        width: 1200px;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .mode-item {
          width: 200px;
          display: flex;
          flex-direction: column;
          align-items: center;
          padding: 10px 0;
          margin-bottom: 30px;

          img {
            width: 50px;
          }

          span {
            margin-top: 18px;
            font-size: 14px;
          }
        }
      }
    }

    .advantage {
      padding-bottom: 100px;
      background-image: url("../../assets/images/advantage.png");
      background-position: center;
      background-size: cover;

      .advantage-list {
        width: 1200px;
        display: flex;
        justify-content: space-between;

        .advantage-item {
          width: 300px;
          height: 300px;
          background-color: #FFFFFF;
          border-radius: 14px;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: space-between;

          span {
            font-weight: 500;
            font-size: 18px;
            color: #FC8B03;
            position: relative;
            top: 30px;
          }

          img {
            width: 300px;
          }
        }
      }
    }

    .range {
      background-color: #f1f1f1;
      background-image: url("../../assets/images/vector.png");
      background-repeat: no-repeat;
      background-size: 100% 95%;

      .range-content {
        width: 100%;
        background-color: #252525;
        display: flex;
        justify-content: center;
        flex-wrap: wrap;

        .range-view {
          width: 1200px;
          height: 150px;
          display: flex;
          align-items: center;
          justify-content: center;

          .range-item {
            width: 300px;

            .title {
              font-size: 14px;
              line-height: 20px;
              color: #BDBDBD;
            }

            .num {
              font-weight: 600;
              font-size: 32px;
              line-height: 59px;
              color: #FC8B03;
              margin-top: 10px;
            }
          }
        }

      }

      .range-desc {
        width: 100%;
        height: 150px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;

        .title {
          font-size: 14px;
          font-weight: bold;
        }

        .desc {
          color: rgba(#666, 0.7);
          margin-top: 10px;
        }
      }
    }

    .company {
      width: 100%;
      display: flex;
      height: 500px;

      img {
        width: 60%;
      }

      .company-content {
        width: 50%;
        padding: 50px 100px;
        background-color: #FFFFFF;

        .title {
          font-weight: 600;
          font-size: 28px;
          line-height: 39px;
        }

        .desc {
          font-weight: normal;
          font-size: 16px;
          line-height: 25px;
          margin: 30px 0;
        }

        .sub-title {
          font-size: 16px;
          font-weight: bold;
        }

        .remarks {
          color: #FB9E2F;
        }

        .sub-content {
          color: rgba(#666, 0.7);
          margin-bottom: 20px;
        }
      }
    }

    .service {
      width: 100%;
      display: flex;
      padding: 80px 0;
      background-color: #FFFFFF;

      .box {
        width: 100%;
        height: 110px;
        background-color: #FC8B03;
      }

      .tel-view {
        display: flex;
        align-items: center;
        padding: 0 72px;
        box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.05);

        img {
          width: 56px;
          height: 56px;
        }

        .call-view {
          margin-left: 10px;
          display: flex;
          flex-direction: column;
          justify-content: center;

          .text {
            // color: rgba(#666, 0.7);
          }

          .tel {
            font-size: 21px;
            // color: #090B17;
          }
        }
      }
    }

    .mode-view {
      display: flex;
      width: 1200px;
      justify-content: space-between;
      align-items: center;

      .pk {
        width: 120px;
        height: 120px;
        background: #FC8B03;
        border-radius: 139px;
        font-weight: 600;
        font-size: 43px;
        line-height: 120px;
        color: #FFFFFF;
        text-align: center;
      }

      .master-view,
      .other-view {
        .title {
          font-weight: 600;
          font-size: 21px;
          line-height: 59px;
          color: #FC8B03;
        }

        .sub {
          width: 180px;
          height: 130px;

          //margin-bottom: 50px;
          .title {
            font-size: 16px;
            line-height: 36px;
            color: #090B17;
          }

          .desc {
            font-size: 14px;
            color: #ABABAC;
          }
        }
      }
    }

    .register-view {
      width: 100%;
      height: 120px;
      background-color: #181818;

      .view {
        width: 1200px;
        height: 100%;
        display: flex;
        margin: 0 auto;
        flex-direction: column;
        justify-content: center;

        .remarks {
          font-weight: 600;
          font-size: 16px;
          line-height: 25px;
          color: #FFFFFF;
        }

        .btn {
          width: 104px;
          height: 40px;
          left: 360px;
          top: 5251px;
          background: #FC8B03;
          margin-top: 10px;
          line-height: 40px;
          text-align: center;
          color: #FFFFFF;
        }
      }
    }

  }
</style>
